import React from 'react'
import ItipsForProduct from '../../../components/common/i-tips/product'
import { Tooltip } from 'antd'
import { urlKey } from '../../../services/api/api-urls'
import { getColModelItem, nbsStr } from '../../../services/lib/utils/helpers'

// Short header with the full meaning available on hover. Long titles used to
// blow up the column widths and force horizontal scrolling on this table.
const headerTitle = (short: string, full: string) => (
  <Tooltip title={full}>
    <span>{short}</span>
  </Tooltip>
)

const MonitorProductColumnModel = () => {
	return [
		{
			title: 'Product Code',
			align: 'left',
			field: 'productCode',
			width: 130,
			render: (rowData: any) => <ItipsForProduct id={rowData.productId} label={rowData.productCode} />,
			// render: (rowData: any) => rowData.product ? <ItipsForProduct id={rowData.productId} label={rowData.product.productName} /> : null
		},
		{
			// No fixed width: this column absorbs the remaining table width.
			title: 'Product Name',
			align: 'left',
			field: 'productName',
			width: 240,
			render: (rowData: any) => <ItipsForProduct id={rowData.productId} label={rowData.productName} />
			// render: (rowData: any) => rowData.product ? <ItipsForProduct id={rowData.productId} label={rowData.product.productName} /> : null
		},

		{
			title: headerTitle('Avail. Stock', 'Available Stock'),
			align: 'left',
			field: 'productInStock',
			width: 90,
			type: 'numeric'
		},

		{
			title: 'Pending Order',
			align: 'left',
			field: 'pendingOrder',
			width: 90,
			type: 'numeric'
		},		
		{
			title: headerTitle('Approved WO', 'Approved Work Order Quantity'),
			align: 'left',
			field: 'pendingWorkOrderQuantity',
			width: 90,
			type: 'numeric'
		},
		{
			title: headerTitle('Approved PO', 'Approved Purchase Order Quantity'),
			align: 'left',
			field: 'poQty',
			width: 90,
			type: 'numeric'
		},		
		// {
		// 	title: 'Approved Purchase Order',
		// 	align: 'left',
		// 	field: 'pendingWarehouseQuantity',
		// 	type: 'numeric'
		// },

		{
			title: headerTitle('MSL', 'Minimum Stock Level'),
			align: 'left',
			field: 'productMsl',
			width: 90,
			type: 'numeric'
		},
		// {
		// 	title: 'In Packaging',
		// 	align: 'left',
		// 	field: 'pendingWarehouseQuantity',
		// 	type: 'numeric'
		// },  
  		
		{
			title: headerTitle('Growth Rate', 'Sales Growth/Decline rate compared to the last 6 months'),
			align: 'left',
			field: 'rate',
			width: 90,
		},  
		{
			title: headerTitle('6M Sales', 'Sales volume in the past 6 months'),
			align: 'left',
			field: 'last6monthsOrderCount',
			width: 90,
			type: 'numeric',
			cellStyle: {
				backgroundColor: '#F0F0F0',
				// color: '#FFF'
			  },			
		},  
		{
			title: headerTitle('LY 6M Sales', "Last year's sales for the same 6-month period"),
			align: 'left',
			field: 'lastlastlast6monthsOrderCount',  //lastlast6monthsOrderCount
			width: 90,
			type: 'numeric',
			cellStyle: {
				backgroundColor: '#F0F0F0',
				// color: '#FFF'
			  },			
		},  
		{
			title: headerTitle('6-12M Sales', 'Sales for the 6 months after the corresponding period last year'),
			align: 'left',
			field: 'lastlast6monthsOrderCount',  //lastlastlast6monthsOrderCount
			width: 90,
			type: 'numeric',
			cellStyle: {
				backgroundColor: '#F0F0F0',
				// color: '#FFF'
			  },			
		},  
			{
			title: headerTitle('Notes', 'Inventory Planning Notes (click to edit)'),
			align: 'left',
			field: 'description',
			width: 180,
			sorting: false,
			render: (rowData: any) => (
				<div
					style={{
						fontSize: '12px',
						color: rowData.description ? '#262626' : '#bfbfbf',
						maxWidth: '100%',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
						cursor: 'pointer',
						borderBottom: rowData.description ? '1px dashed #1890ff' : '1px dashed #d9d9d9',
					}}
					onClick={() => (window as any).__openInventoryNotes?.(rowData)}
					title={rowData.description || 'Click to add Inventory Planning Notes'}
				>
					{rowData.description || '+ Add notes'}
				</div>
			),
		},

		{
			title: 'Low Stock',
			align: 'center',
			field: 'isLowStock',
			width: 90,
			defaultFilter: ['1'],
			lookup: {0: 'No', 1: 'Yes'},
			// formatter: 'tickCross', 		
      // defaultFilter: ['1'],
      // lookup: { 1: 'InProcessing', 10: 'Completed' },      			
		},  		
		
  ]
}

export default MonitorProductColumnModel
